export const trackEvent = (eventName, params) => {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, params);
};